import classnames from 'classnames';
import React from 'react';
import SortIcon from 'components/helpers/SvgIcon/icons/sortIcon';

type SortFucntionType = (column: string, isAscending: boolean) => number;
interface TableHeadingProps {
  label?: string;
  sortTable: SortFucntionType;
  sortIndicator: {
    columName: string;
    isAscending: boolean;
  };
  showSortIcon?: boolean;
  columnKey?: string | null;
}
const TableHeading = ({
  label,
  sortIndicator,
  sortTable,
  showSortIcon,
  columnKey,
}: TableHeadingProps) => {
  const columnName = columnKey ?? label;
  return (
    <div className={classnames('flex', 'flex-row', 'content-center')}>
      {label}
      {showSortIcon && (
        <div className={classnames('hidden', 'md:block', 'ml-auto')}>
          <span className={classnames('flex', 'flex-col', 'content-center', 'ml-2')}>
            <button
              className={classnames('pl-2.5', 'underline')}
              type="button"
              onClick={() => sortTable(columnName as string, false)}
              aria-label={`Sort by ${label} descending`}
            >
              <SortIcon
                color={
                  sortIndicator.columName === columnName && !sortIndicator.isAscending
                    ? 'black'
                    : '#AAAAAD'
                }
                inverted={false}
              />
            </button>
            <button
              className={classnames('pl-2.5', 'underline')}
              type="button"
              onClick={() => sortTable(columnName as string, true)}
              aria-label={`Sort by ${label} ascending`}
            >
              <SortIcon
                color={
                  sortIndicator.columName === columnName && sortIndicator.isAscending
                    ? 'black'
                    : '#AAAAAD'
                }
                inverted
              />
            </button>
          </span>
        </div>
      )}
    </div>
  );
};

export default TableHeading;
